module.exports = __webpack_public_path__ + "img/gift-1.ae2bca05.png";